import { Injectable } from '@angular/core';
import { ComplexFormParent } from '../utils/complex-form-parent';
import { SurveyModel } from 'survey-core';

@Injectable({
  providedIn: 'root'
})
export class BranchOfficeService extends ComplexFormParent {

  override initializeForm() {
    super.initializeForm();
    this.surveyService.surveyModel.setValue('main_office_id', this.surveyService.officeId);
  }

  override initializeOnAfterRenderPage() {
    super.initializeOnAfterRenderPage();
  }

  override initializeOnCurrentPageChanging() {
    super.initializeOnCurrentPageChanging();
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch (currentPage.name) {
        case 'Confirmation':
          this.buildOrderConfirmation('new_branch');
          break;
        case 'Your Details':
          if (this.surveyService.personRelationships) {
            const mainRelationship = this.surveyService.personRelationships.find(r => r.is_main_relationship === true);
            if (mainRelationship && mainRelationship.role_type === 'MLO') {
              this.surveyService.surveyModel.setVariable('can_create_office', false);
            } else {
              this.surveyService.surveyModel.setVariable('can_create_office', true);
            }
          }
          break;
      }
    });
  }

  override initializeOnValueChanged() {
    super.initializeOnValueChanged();
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
      if (options.name == 'office') {
        const officeIdSelected = sender.getValue('office');
        if (officeIdSelected) {
          this.surveyService.isLoading = true;
          this.officesApiService.getOffice(officeIdSelected).subscribe({
            next: (office: any) => {
              sender.setVariable('selected_office', office);
              sender.setVariable('office_name', office.business_name);
              sender.setVariable('dr_name', office.field_description.designated_realtor);
              this.surveyService.isLoading = false;
              this.validateMlsOfChoice(office);
            },
            error: (error) => {
              this.surveyService.isLoading = false;
              this.errorsService.processError(error, 'soft')
            }
          });
        }
      }
    });
  }
}
